import React, { useMemo, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { portfolioData } from "../../constant/constant";
import { ModalView } from "../modal/ModalView";
import ProgressiveImage from "../ProgressiveImage";

const filters = ["All", "Mobile", "Web", "Machine Learning"];

const projectCardTechnologies = {
  MyPB: ["Firebase", "React Native", "Redux", "Swift", "Java", "JavaScript"],
  "PB Enterprise": ["React Native", "RTK Query", "TypeScript"],
  PBeXperience: [
    "Firebase",
    "React Native",
    "Redux",
    "Swift",
    "Java",
    "TypeScript",
  ],
  "PB Journey": ["React Native", "Redux", "JavaScript"],
  "MyPB Laos": ["React Native", "Redux", "JavaScript"],
  UKMeals: ["HTML", "PHP", "CSS", "JavaScript", "MySQL"],
  "Chaos Creator": ["ReactJS", "TailwindCSS"],
  "TikGram Downloader": ["Python", "Selenium", "Kivy", "Scrapy"],
  "ZUS Coffee Clone App": ["React Native", "Redux", "JavaScript"],
  UKMall: ["Java", "Firebase", "XML"],
  "Twitter Analyzer": ["Rapid Miner", "Twitter API"],
};

const technologyColors = {
  Firebase: "#ffca28",
  "React Native": "#61dafb",
  Redux: "#764abc",
  Swift: "#f05138",
  Java: "#e76f00",
  JavaScript: "#f7df1e",
  "RTK Query": "#764abc",
  TypeScript: "#3178c6",
  HTML: "#e34f26",
  PHP: "#777bb4",
  CSS: "#1572b6",
  MySQL: "#4479a1",
  ReactJS: "#0a9fc7",
  TailwindCSS: "#06b6d4",
  Python: "#3776ab",
  Selenium: "#43b02a",
  Kivy: "#37b5a5",
  Scrapy: "#60a839",
  XML: "#f26522",
  "Rapid Miner": "#f5a623",
  "Twitter API": "#1da1f2",
};

const projectDescriptions = {
  MyPB: "Public Bank mobile banking app",
  "PB Enterprise": "Corporate mobile banking app",
  PBeXperience: "Employee banking and lifestyle app",
  "PB Journey": "Secure savings app for youths",
  "MyPB Laos": "Mobile banking app for Laos",
  UKMeals: "UKM food ordering and delivery platform",
  "Chaos Creator": "Personal software engineering portfolio",
  "TikGram Downloader": "Social media content downloader",
  "ZUS Coffee Clone App": "React Native coffee ordering experience",
  UKMall: "Mobile marketplace for UKM students",
  "Twitter Analyzer": "Social media sentiment analysis tool",
};

const getShortDescription = (item) => {
  return (
    item.shortDescription ||
    projectDescriptions[item.title] ||
    `${item.category?.[0] || "Digital"} project`
  );
};

const Portfolio = () => {
  const [active, setActive] = useState("All");
  const [selected, setSelected] = useState(null);
  const items = useMemo(
    () =>
      active === "All"
        ? portfolioData
        : portfolioData.filter((item) => item.category?.includes(active)),
    [active],
  );

  const openProject = (item) => setSelected(item);

  return (
    <section id="portfolio" className="section">
      <p className="eyebrow">Projects</p>
      <h2 className="section-title">Projects that show the craft.</h2>

      <div className="portfolio-filter">
        {filters.map((filter) => (
          <button
            className={active === filter ? "active" : ""}
            onClick={() => setActive(filter)}
            key={filter}
          >
            {filter}
          </button>
        ))}
      </div>

      <div className="projects">
        {items.map((item) => (
          <article
            className="panel project-card"
            key={item.title}
            onClick={() => openProject(item)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                openProject(item);
              }
            }}
            role="button"
            tabIndex={0}
            aria-label={`Open ${item.title} case study`}
          >
            <div className="project-card-media">
              <ProgressiveImage
                src={item.image[0]}
                alt={`${item.title} preview`}
              />
              <span className="project-card-arrow" aria-hidden="true">
                <FaArrowRight />
              </span>
            </div>
            <div className="project-card-heading">
              <h3>
                {item.title} — {getShortDescription(item)}
              </h3>
            </div>
            <div className="project-card-tech" aria-label="Technologies used">
              {(
                projectCardTechnologies[item.title] ||
                item.technology ||
                []
              ).map((technology) => (
                <span
                  key={technology}
                  style={{
                    "--tech-color": technologyColors[technology] || "#275dff",
                  }}
                >
                  {technology}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      {selected && (
        <ModalView
          isOpen={Boolean(selected)}
          onClose={() => setSelected(null)}
          selectedItem={selected}
        />
      )}
    </section>
  );
};

export default Portfolio;
